import { PARTNER } from '@/types';

const partnerList: Record<PARTNER, string> = {
  [PARTNER.skymark]: 'Skymark',
  [PARTNER.guep]: 'GUEP',
} as const;

export const getPartnerLabel = (partner: PARTNER): string => partnerList[partner] || 'Gerenciadora de risco';
